import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow, StyledFlex } from "@/common/styles";
import QuickSearchBookings from "@/components/SearchForms/QuickSearchBookings";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form, message } from "antd";
import Select from "@/common/elements/InputElements/Select";
import dayjs from "dayjs";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { useEffect, useState } from "react";
import Button from "@/common/elements/Button";
import { MODULES_LIST } from "@/util/common_variable";

const BookingsFilter = ({
  isFindModalVisible,
  setIsFindModalVisible,
  onHandleCancel,
  setReportListData,
  setReportListTotal,
  setBookingSearchPayload,
  setPagination,
  setIsFiltered,
  apiModule = MODULES_LIST.BOOKINGS,
  path = MODULES_LIST.STAFF,
}) => {
  const [searchForm] = Form.useForm();
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    searchForm.resetFields();
  }, [isFindModalVisible]);

  const fetchSearchResults = async () => {
    const values = await searchForm.validateFields();
    const filteredEntries = Object.entries(values).filter(([key, value]) => {
      if (dayjs.isDayjs(value)) {
        return value;
      }
      return value !== undefined && value !== null && value !== "";
    });
    const payload = filteredEntries.map(([key, value]) => {
      const formattedValue = dayjs.isDayjs(value)
        ? value.format("MM/DD/YYYY")
        : value;

      if (
        [
          "height",
          "weight",
          "ageAtEntry",
          "heightPlusOrMinus",
          "weightPlusOrMinus",
          "agePlusOrMinus",
        ].includes(key)
      ) {
        return { filterKey: key, value: Number(value) };
      }

      if (key === "juvenile") {
        if (value === "No Juveniles") {
          return { filterKey: key, value: 0 };
        } else if (value === "Only Juveniles") {
          return { filterKey: key, value: 1 };
        }
        return null;
      }

      return { filterKey: key, value: formattedValue };
    });

    setBookingSearchPayload(payload);
    let url = API_ENDPOINTS.bookingsSearch + "?size=100&direction=desc";
    if (apiModule == MODULES_LIST.STAFF) {
      url = API_ENDPOINTS.staff.searchStaff + "?size=100&direction=desc";
    }
    const response = await api.post(url, payload);

    return response.data;
  };

  const onHandelFindGo = async () => {
    try {
      setIsloading(true);
      setReportListData([]);
      setPagination({
        pageIndex: 0,
        pageSize: 100,
      });

      const data = await fetchSearchResults();
      if (!isFindModalVisible) {
        return;
      }

      if (isNonEmptyVariable(data)) {
        if (apiModule == MODULES_LIST.STAFF) {
          let rowData = data.rows;
          if (isNonEmptyVariable(rowData)) {
            let rowData2 = rowData.map((a, i) => {
              let obj = {};
              obj.staffId = a.staffID;
              obj.name = a?.name;
              obj.badgeNumber = a?.badgeNumber;
              obj.rank = a?.rank;
              obj.division = a?.division;
              obj.username = a.username;
              obj.agency = a?.agency;
              return obj;
            });

            // setBookingSearchPayload([
            //   { filterKey: "searchType", value: "Starts With" },
            // ]);
            setReportListData((prev) => ({
              ...prev,
              rows: rowData2,
            }));
            setReportListTotal(data?.total);
            setIsFiltered(true);
          }
        } else {
          setReportListData(() => data?.rows);
          setReportListTotal(data?.total);
          setIsFiltered(true);
        }
      }

      message.success("Search completed successfully");
    } catch (err) {
      message.error("Search failed");
    } finally {
      setIsloading(false);
      setIsFindModalVisible(false);
    }
  };

  return (
    <Modal
      show={isFindModalVisible}
      size="lg"
      width="62%"
      header="Quick Search"
      designPattern="ant"
      maskClosable={false}
      onHide={onHandleCancel}
      handleCancel={onHandleCancel}
      footerActionsNeed={false}
    >
      <Form
        form={searchForm}
        layout="vertical"
        initialValues={{ searchType: "Starts With" }}
      >
        <QuickSearchBookings path={path} />
        <StyledGridRow
          className="ant-modal-footer custom"
          justify="space-between"
        >
          <StyledGridCol>
            <FormItem label="Search Type" layout="horizontal" name="searchType">
              <Select
                options={getOptionsFromRefList("Search_Type")}
                style={{ minWidth: "148px" }}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <StyledFlex gap="10px">
              {/* <Button onClick={onGetCount} loading={countLoading}>
                Count
              </Button> */}
              <Button
                color="default"
                type="default"
                onClick={onHandelFindGo}
                loading={isLoading}
              >
                Go
              </Button>
              <Button color="default" type="default" onClick={onHandleCancel}>
                Cancel
              </Button>
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </Modal>
  );
};

export default BookingsFilter;
